import { cipo } from "cipo";

cipo.controller(
  "editCategoryGroupsController",
  function ($scope, $mdDialog) {

    $scope.expanded = false;

    $scope.expandCollapse = function () {
      $scope.expanded = !$scope.expanded;
    }

    $scope.onSave = function () {
      $mdDialog.hide(true);
    };

    $scope.onClose = function (status) {
      $mdDialog.cancel(status);
    };
  }
);
